var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChecklistItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.512 10.472 23 11.984l-6.984 7.032-4.536-4.512 1.488-1.488 3.048 3zM2 14.984v-1.968h7.968v1.968zM14 5v2.016H2V5zm0 3.984V11H2V8.984z",
  clipRule: "evenodd"
})));
export default SvgChecklistItem;